{
  "shared": {
    "money": {
      "roundingVariance": "Rounding variance"
    }
  }
}
